<div class="header">
  <h3>{{ 'sources.configuration.setTemplate.title' | translate }}</h3>
  <mat-icon mat-dialog-close>close</mat-icon>
</div>

<div class="content">
  <mat-form-field>
    <mat-label>{{ "sources.configuration.setTemplate.templateName" | translate }}</mat-label>
    <input [formControl]="templateNameControl" matInput/>
  </mat-form-field>
</div>

<div class="controls">
  <button class="cancel-button" mat-button (click)="cancel.emit()">
    {{ "system.cancel" | translate | uppercase }}
  </button>
  <button class="copy-button" mat-raised-button (click)="onSave()" [disabled]="templateNameControl.invalid">
    {{ "system.save" | translate | uppercase }}
  </button>
</div>
